import React from 'react'
import styles from './apply.scss'
import apply from '../../../common/images/solution/apply.jpg'
import one from '../../../common/images/solution/01.png'
import two from '../../../common/images/solution/02.png'
import three from '../../../common/images/solution/03.png'
import four from '../../../common/images/solution/04.png'
import circular from '../../../common/images/solution/circular.png'
import solutions from '../../../common/images/solution/solution.png'
import apply_1 from '../../../common/images/solution/apply-1.jpg'
import yd_apply from '../../../common/images/solution/yd-apply.png'
import apply_2 from '../../../common/images/solution/apply-2.jpg'
import apply_3 from '../../../common/images/solution/apply-3.jpg'
import apply_4 from '../../../common/images/solution/apply-4.jpg'
import apply_5 from '../../../common/images/solution/apply-5.jpg'
import one_x from '../../../common/images/solution/01-x.png'
import two_x from '../../../common/images/solution/02-x.png'
import three_x from '../../../common/images/solution/03-x.png'
import fous_x from '../../../common/images/solution/04-x.png'

const Apply = (props) => {
  return <section className={styles['apply']}>
    <div className={styles['bill']}>
      <img src={apply} alt='apply' className={styles['bill_img']} />
      <img src={yd_apply} alt='yd_apply' className={styles['bg_bill_img']} />
      <div className={styles['bill-content']}>
        <h2>报销管理</h2>
        <p>打通报销业务全流程，缩短报销周期，提高内控能力。</p>
      </div>
    </div>
    <div className={styles['industry-pain']}>
      <h3>行业痛点</h3>
      <ul>
        <li>
          <div className={styles['industry-h']}>
            <div><img src={one} alt='01' className={styles['industry-one']} /></div>
            <h4>发票查重验真难</h4>
          </div>
          <div className={styles['industry-p']}>
            <span></span>
            <p>
            人工发票审核效率低且易出错，虚假发票、重复发票难筛选。
            </p>
          </div>
        </li>
        <li>
          <div className={styles['industry-h']}>
            <div><img src={two} alt='02' /></div>
            <h4>层层审批耗时久</h4>
          </div>
          <div className={styles['industry-p']}>
            <span className={styles['industry-s2']}></span>
            <p>
            一次报销经历层层审批，错审漏审状况频发，员工老板双方都苦不堪言。
            </p>
          </div>
        </li>
        <li>
          <div className={styles['industry-h']}>
            <div><img src={three} alt='03' /></div>
            <h4>报销流程难调整</h4>
          </div>
          <div className={styles['industry-p']}>
            <span className={styles['industry-s3']}></span>
            <p>
            公司结构复杂的情况下，传统报销软件不适应公司审批流程，且无法自定义设置。
            </p>
          </div>
        </li>
        <li>
          <div className={styles['industry-h']}>
            <div><img src={four} alt='04' /></div>
            <h4>报销费用无统计</h4>
          </div>
          <div className={styles['industry-p']}>
            <span className={styles['industry-s4']}></span>
            <p>
            报销无统计报表，各项申请杂乱无章，财务难做账。
            </p>
          </div>
        </li>
      </ul>
      <img src={solutions} alt='solutions' className={styles['solutions']} />
      <img src={circular} alt='circular' className={styles['circular']} />
    </div>
    <div className={styles['scheme']}>
      <h3>解决方法</h3>
      <p className={styles['scheme-wz']}>打通报销业务全流程，缩短报销周期，提高内控能力。</p>
      <div className={styles['scheme_content']}>
        <img src={apply_1} alt='apply_1' className={styles['gather']} />
        <div>
          <img src={one_x} alt='one-x' className={styles['one-x']} />
          <h4>发票智能采集、验真、去重</h4>
          <p>
          支持电票原件上传、微信卡包获取、二维码扫描、手动填写发票要素等多种发票采集方式；可对报销发票进行OCR自动识别、验真、查重、价税分离，并对报销单去重，智能识票节约企业隐形成本。
          </p>
        </div>
      </div>
      <div className={`${styles.scheme_content}`}>
        <div className={`${styles.scheme_two}`}>
          <img src={two_x} alt='two-x' className={styles['two-x']} />
          <h4>手机移动审批</h4>
          <p>
          概而论小程序支持日常报销、出差报销、无票支付、代收代付、备用款申请、采购报备等项目申请，支持移动审批，便于用户随时发起单据，查看报销进度。
          </p>
        </div>
        <img src={apply_2} alt='apply_2' className={styles['fetch']} />
      </div>
      <div className={styles['scheme_content']}>
        <img src={apply_3} alt='apply_3' className={styles['print']} />
        <div className={`${styles.scheme_three}`}>
          <img src={three_x} alt='three-x' className={styles['three-x']} />
          <h4>自定义报销审批流程</h4>
          <p>
          支持审批流程自定义，贴合企业自身情况，企业全流程管控实现报销管理闭环。
          </p>
        </div>
      </div>
      <div className={styles['scheme_content']}>
        <div className={`${styles.scheme_fous}`}>
          <img src={fous_x} alt='fous-x' className={styles['fous-x']} />
          <h4>自定义报销费用类型</h4>
          <p>
          费用类型支持用户事前自定义配置，可按照企业需求进行管控。
          </p>
        </div>
        <img src={apply_4} alt='apply_4' className={styles['ticket']} />
      </div>
      <div className={styles['scheme_content']}>
        <img src={apply_5} alt='apply_5' className={styles['apply-5']} />
        <div className={`${styles.scheme_five}`}>
          <div className={styles['five-x']}>05</div>
          <h4>报销费用多维统计</h4>
          <p>
          用户可于电脑PC端与手机移动端，根据组织机构、年月期间和业务主体，按单据类型、费用类型查看各项费用类型的报销情况；概而论云报销电脑端统计报表可导出成Excel格式，便于用户打印查看。
          </p>
        </div>
      </div>
    </div>
  </section>
}

export default Apply
